// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuex from 'vuex';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
//import FileTree from "./components/common/FileTree";
import Notifications from 'vue-notification';
import Spinner from 'vue-simple-spinner';
import Vuelidate from 'vuelidate';
import VueTransmit from 'vue-transmit';

import App from './App';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import ProcessQueue from './components/ProcessQueue';
import Settings from './components/Settings/Settings';

import router from './router';
import store from './store';
import filters from './filters/filters';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(Spinner);
Vue.use(Vuelidate);
Vue.use(VueTransmit);

// Vue.use(FileTree);

Vue.component('spinner', Spinner);
// Vue.component("file-tree", FileTree);

Vue.component(Sidebar.name, Sidebar);
Vue.component(Topbar.name, Topbar);
Vue.component(Navbar.name, Navbar);
Vue.component(ProcessQueue.name, ProcessQueue);
Vue.component(Settings.name, Settings);

import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/fonts.scss';
import './sass/app.scss';
// import "./sass/main.scss";

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});
